import React from 'react';
import Chart from 'react-apexcharts';

export default function PieChart() {
  // const data = {
  //   datasets: [
  //     {
  //       label: 'Leads',
  //       data: [12, 2],
  //       backgroundColor: [
  //         "#3C1EB5",
  //         '#0174D8',
  //       ],
  //       borderColor: [
  //         '#3C1EB5',
  //         '#0174D8',
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  //   labels: ['B2B', 'B2C'],
  // };
  const data = {
    series: [44, 55],
    options: {
      chart: {
        width: 380,
        type: 'pie',
      },
      colors: ['#3C1EB5', '#0174D8'],
      labels: ['B2B', 'B2C'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  }

  return (
    <>
      <div className="pie-chart">
        <h6>Annually Lead chart</h6>
      </div>
      <div className="chart">
        <Chart options={data.options} series={data.series} type="pie" width={380} />
      </div>
    </>
  );
}

